import { NavigationConfig } from './types'

export const navigationConfig: NavigationConfig = {
    mainItems: [
        {
            label: 'Home',
            value: 'dashboard',
            href: '/',
            icon: 'house',
            enabled: true,
        },
        {
            name: 'Paid Advertising',
            label: 'Paid Advertising',
            value: 'storefronts',
            icon: 'advertising',
            items: [
                {
                    label: 'Create with AI',
                    value: 'createPostClickCreative',
                    href: '/landingpages/create/ai-wizard',
                    enabled: true,
                    hasSparkles: true,
                },
                {
                    label: 'Full Funnel',
                    value: 'fullFunnelCreative',
                    href: '/full-funnel-creative',
                    enabled: false,
                    comingSoon: true,
                },
                {
                    label: 'Ad Creative',
                    value: 'adCreative',
                    href: '/ad-creative',
                    enabled: false,
                    comingSoon: true,
                },
                {
                    label: 'Post-click Creative',
                    value: 'postClickCreative',
                    href: '/landingpages',
                    enabled: true,
                },
            ],
            enabled: true,
            defaultIsOpen: true,
        },
        {
            name: 'Email and SMS',
            label: 'Email and SMS',
            value: 'emailAndSms',
            icon: 'email',
            items: [
                {
                    label: 'Full Funnel',
                    value: 'creativeAnalytics',
                    href: '/creative-analytics',
                    enabled: false,
                },
                {
                    label: 'Email Creative',
                    value: 'emailCreative',
                    href: '/email-creative',
                    enabled: false,
                },
                {
                    label: 'SMS Creative',
                    value: 'smsCreative',
                    href: '/sms-creative',
                    enabled: false,
                },
                {
                    label: 'Post-click Creative',
                    value: 'emailAndSmsPostClickCreative',
                    href: '/emailandsms-postclick',
                    enabled: true,
                },
                {
                    label: 'Smart ID',
                    value: 'smartId',
                    href: '/smart-id',
                    enabled: false,
                },
                {
                    label: 'Predictive Offer',
                    value: 'predictiveOffer',
                    href: '/predictive-offer',
                    enabled: false,
                },
            ],
            enabled: true,
            defaultIsOpen: true,
        },
        {
            name: 'Analytics',
            label: 'Analytics',
            value: 'analytics',
            icon: 'graph',
            items: [
                {
                    label: 'Full Funnel Creative',
                    value: 'fullFunnelCreative',
                    href: '/full-funnel-creative',
                    enabled: false,
                },
                {
                    label: 'Post-click Creative',
                    value: 'postClickCreative',
                    href: '/explo',
                    enabled: false,
                },
                {
                    label: 'Post-click Performance',
                    value: 'storefront-comparison',
                    href: '/storefront-comparison',
                    enabled: false,
                },
                {
                    label: 'Post-click Creatives',
                    value: 'postClickCreatives',
                    href: '/storefront-comparison',
                    enabled: true,
                },
                {
                    label: 'Post-click Comparison',
                    value: 'postClickComparison',
                    href: '/explo/post-click-explorer',
                    enabled: true,
                },
            ],
            enabled: true,
            defaultIsOpen: false,
        },
        {
            name: 'Assets',
            label: 'Assets',
            value: 'assets',
            icon: 'video',
            items: [
                {
                    label: 'Link Management',
                    value: 'linkManagement',
                    href: '/crowlinks',
                    enabled: true,
                    comingSoon: false,
                },
                {
                    label: 'Personas',
                    value: 'personas',
                    href: '/personas',
                    enabled: true,
                    comingSoon: false,
                },
                {
                    label: 'Videos',
                    value: 'videos',
                    href: '/videos',
                    enabled: true,
                },
                {
                    label: 'Video Playlists',
                    value: 'playlists',
                    href: '/playlists',
                    enabled: false,
                },
                {
                    label: 'Products',
                    value: 'products',
                    href: '/products',
                    enabled: true,
                },
                {
                    label: 'Ad Assets',
                    value: 'adAssets',
                    href: '/ad-assets',
                    enabled: true,
                    comingSoon: true,
                },
            ],
            enabled: true,
            defaultIsOpen: true,
        },
        {
            name: 'Settings',
            label: 'Settings',
            value: 'settings',
            icon: 'gear',
            items: [
                {
                    label: 'Brand Center',
                    value: 'customization',
                    href: '/settings',
                    enabled: true,
                },
                {
                    label: 'Tracking Pixels',
                    value: 'trackingPixels',
                    href: '/trackingpixels',
                    enabled: true,
                },
                {
                    label: 'Reviews',
                    value: 'reviews',
                    href: '/reviews',
                    enabled: true,
                },
            ],
            enabled: true,
            defaultIsOpen: false,
        },
    ],
    bottomItems: [],
    userMenu: [
        {
            label: 'Users',
            value: 'users',
            href: '/team',
            enabled: true,
            icon: 'team',
        },
        {
            label: 'Billing',
            value: 'billing',
            href: '/billing',
            enabled: true,
            icon: 'credit-card',
        },
        {
            label: 'Support',
            value: 'supportCenter',
            href: 'https://blackcrow.zendesk.com/hc/en-us/categories/30800308031003-Product-Information-Paid-Storefronts',
            enabled: true,
            openInNewTab: true,
            icon: 'support-center',
        },
    ],
}
